import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";

export default function AdminNews() {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ headline: "", link: "", active: true, priority: 5 });

  const load = () => api.get("/admin/news").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/admin/news", { ...form, priority: parseInt(form.priority) });
      toast.success("Saved");
      setShow(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => {
    if (!confirm("Delete?")) return;
    await api.delete(`/admin/news/${id}`); load();
  };

  return (
    <div data-testid="admin-news">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.3em] brand-orange mb-3">// CMS · News Ticker</div>
          <h1 className="font-display text-4xl font-black uppercase tracking-tighter leading-none">News Ticker.</h1>
        </div>
        <button onClick={() => setShow(true)} data-testid="new-news-btn" className="bg-brand-blue text-white px-5 py-2 text-xs uppercase font-bold tracking-widest flex items-center gap-2">
          <Plus size={12} /> New Headline
        </button>
      </div>

      <div className="space-y-2">
        {items.map((n) => (
          <div key={n.id} className="border border-white/12 bg-[#131A2B] p-4 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <span className={`w-2 h-2 rounded-full ${n.active ? "bg-brand-blue" : "bg-white/20"}`}></span>
              <div>
                <div className="font-medium">{n.headline}</div>
                <div className="text-xs font-mono text-white/40">Priority {n.priority}</div>
              </div>
            </div>
            <button onClick={() => del(n.id)} className="text-white/60 hover:text-red-400"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>

      {show && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setShow(false)}>
          <div className="bg-[#131A2B] border border-white/12 p-8 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-display text-2xl uppercase font-black">New Headline</h3>
              <button onClick={() => setShow(false)}><X size={18} /></button>
            </div>
            <div className="space-y-3">
              <input value={form.headline} onChange={(e) => setForm({ ...form, headline: e.target.value })} placeholder="Headline" data-testid="news-headline" className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <input type="number" value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} placeholder="Priority (0-10)" className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} /> Active</label>
              <button onClick={save} data-testid="news-save" className="w-full bg-brand-blue text-white py-3 font-bold uppercase tracking-widest">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
